import React, { useEffect, useState } from 'react';
import styles from '../Step2/Step2.module.css';
import { useProjectStore } from '../../../../Stores/ProjectStore';
import { useMediaType } from '@shared/Hooks/useMediaTypeHook';
import { ViewItemTypesModeEnum } from '@modules/Steps/Shared/Enums/ViewItemTypesModeEnum';
import { BasicLoader } from '@shared/Ui/Loaders/BasicLoader/BasicLoader';
import { useNavigate, useParams } from 'react-router-dom';
import BasicButton from '@shared/Ui/Buttons/BasicButton/BasicButton';
import css from './Step3.module.css';
import { CartIcon } from '@shared/Icons/CartIcon';
import { GrandTotalStep3Buttons } from '@modules/Steps/Components/Step3/GrandTotalStep3Buttons/GrandTotalStep3Buttons';
import { StepsViewModeEnum } from '@shared/Enums/StepsViewModeEnum';
import { BOMProjectExampleData } from '@mockData/BOMProjectExampleData';
import { ROUTES } from '@configs/AppRoutes';
import { UserGuideKeyEnum } from '@shared/Enums/UserGuideKeyEnum';
import { useUserGuideTour } from '@shared/Hooks/useUserGuideTour';
import { CustomProjectStep3UserGuide } from '@modules/Steps/UserGuideSteps/CustomProjectStep3UserGuide';
// import Joyride from 'react-joyride';
import { JoyrideStyles } from '@styles/GlobalJoyrideStyles/JoyrideStyles';
import { UserGuideCursor } from '@shared/Ui/UserGuideCursor/UserGuideCursor';
import GrandTotalSelectedFooter from '@shared/Widgets/GrandTotalSelectedFooter/GrandTotalSelectedFooter';
import Step3MobileContent from '@modules/Steps/Components/Step3/Step3MobileContent/Step3MobileContent';
import Step3DesktopContent from '@modules/Steps/Components/Step3/Step3DesktopContent/Step3DesktopContent';
import { CustomProjectInfoViewModel } from '@viewModels/CustomProjectInfoViewModel';
import { FragmentsViewModel } from '@viewModels/FragmentsViewModel/FragmentsViewModel';
import { ItemsSelectionViewModel } from '@viewModels/ItemsSelectionViewModel/ItemsSelectionViewModel';
import { useFragmentsStore } from '../../../../Stores/FragmentsStore';
import { useItemsSelectionStore } from '../../../../Stores/ItemsSelectionStore';
import { TemplateMainInfoSection } from '@modules/Steps/Shared/Ui/Headers/TemplateMainInfoSection/TemplateMainInfoSection';
import { MockRawGalleries } from '@mockData/MockRawGalleries';
import { useTemplatesViewModel } from '@viewModels/TemplatesViewModel/TemplatesViewModel';

const Step3: React.FC = () => {
    const { customProject } = useProjectStore();

    const {
        parsedFragments,
        fragmentsViewMode,
        laborItemTypes,
        toolItemTypes,
        fragmentsWithMaterialItemTypes,
    } = useFragmentsStore();

    const { currentTemplate } = useTemplatesViewModel();
    const { selectedItems } = useItemsSelectionStore();

    const customProjectInfoViewModel = new CustomProjectInfoViewModel();
    const fragmentsViewModel = new FragmentsViewModel();
    const selectedItemsViewModel = new ItemsSelectionViewModel();

    const [step3ProjectLoading, setStep3ProjectLoading] =
        useState<boolean>(false);

    const { projectId, viewMode } = useParams();
    const [isDesktop] = useMediaType();

    const navigate = useNavigate();

    const fragments =
        fragmentsViewMode === ViewItemTypesModeEnum.WorkStage
            ? parsedFragments
            : fragmentsWithMaterialItemTypes;

    // const steps = CustomProjectStep3UserGuide;
    //
    // const tourKey = UserGuideKeyEnum.CUSTOM_PROJECT_STEP3_GUIDE;
    // const { runTour, handleJoyrideCallback, stepIndex, cursorPositions } =
    //     useUserGuideTour(
    //         tourKey,
    //         isDesktop && viewMode === StepsViewModeEnum.PROJECT,
    //         steps
    //     );

    const grandTotal = selectedItemsViewModel.getSelectedItemsGrandTotal();
    const toolsTotal = selectedItemsViewModel.getSelectedToolItemsTotal();
    const materialsTotal =
        selectedItemsViewModel.getSelectedMaterialItemsTotal();
    const labourTotal = fragmentsViewModel.getFragmentsLabourItemTotal();

    const fetchStep3Data = async () => {
        setStep3ProjectLoading(true);
        try {
            await customProjectInfoViewModel.getCustomProject(
                Number(projectId)
            );
            await fragmentsViewModel.getParsedFragments(Number(projectId));
            await fragmentsViewModel.getGalleryData();
        } finally {
            setStep3ProjectLoading(false);
        }
    };

    useEffect(() => {
        if (viewMode === StepsViewModeEnum.PROJECT) {
            fetchStep3Data();
        } else {
            customProjectInfoViewModel.getExampleProject(BOMProjectExampleData);
            fragmentsViewModel.getExampleGalleryData(MockRawGalleries);
        }
    }, []);

    const handleShowTemplateInfo = () => {
        if (currentTemplate && currentTemplate.id) {
            navigate(ROUTES.TEMPLATE_INFO.getPath(String(currentTemplate.id)));
        } else {
            navigate(ROUTES.BOM);
        }
    };

    if (step3ProjectLoading) {
        return <BasicLoader />;
    }

    return (
        <>
            <section className={styles.section}>
                <div className={styles.wrapper}>
                    <TemplateMainInfoSection project={customProject} />

                    {isDesktop ? (
                        <Step3DesktopContent
                            fragments={fragments}
                            fragmentsViewMode={fragmentsViewMode}
                            laborItemTypes={laborItemTypes}
                            toolItemTypes={toolItemTypes}
                        />
                    ) : (
                        <Step3MobileContent
                            fragments={fragments}
                            fragmentsViewMode={fragmentsViewMode}
                            laborItemTypes={laborItemTypes}
                            toolItemTypes={toolItemTypes}
                        />
                    )}
                </div>
                <GrandTotalSelectedFooter
                    grandTotal={grandTotal}
                    toolsTotal={toolsTotal}
                    materialsTotal={materialsTotal}
                    laboursTotal={labourTotal}
                    runTour={false}
                >
                    {viewMode === StepsViewModeEnum.PROJECT ? (
                        <GrandTotalStep3Buttons />
                    ) : (
                        <BasicButton
                            extraClassName={css.btn}
                            onClick={handleShowTemplateInfo}
                        >
                            <div className={css.btnContent}>
                                <CartIcon fill="currentColor" />
                                PURCHASE A TEMPLATE TO COMPLETE
                            </div>
                        </BasicButton>
                    )}
                </GrandTotalSelectedFooter>
            </section>
            {/*{runTour && (*/}
            {/*    <Joyride*/}
            {/*        steps={steps}*/}
            {/*        run={runTour}*/}
            {/*        stepIndex={stepIndex}*/}
            {/*        spotlightClicks={true}*/}
            {/*        continuous={false}*/}
            {/*        disableScrollParentFix={true}*/}
            {/*        disableOverlayClose={false}*/}
            {/*        callback={handleJoyrideCallback}*/}
            {/*        showProgress={false}*/}
            {/*        showSkipButton={true}*/}
            {/*        styles={JoyrideStyles}*/}
            {/*    />*/}
            {/*)}*/}
            {/*{runTour &&*/}
            {/*    cursorPositions.length > 0 &&*/}
            {/*    cursorPositions.map((position, index) => (*/}
            {/*        <UserGuideCursor*/}
            {/*            key={index}*/}
            {/*            top={position.top}*/}
            {/*            left={position.left}*/}
            {/*        />*/}
            {/*    ))}*/}
        </>
    );
};

export default Step3;
